import { BookServiceService } from "./../services/book-service.service";
import { Component, OnInit, Input } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
@Component({
  selector: "app-user-books",
  templateUrl: "./user-books.component.html",
  styleUrls: ["./user-books.component.scss"]
})
export class UserBooksAComponent implements OnInit {
  constructor($http: HttpClientModule, private ser: BookServiceService) {}
  books: any;
  title;

  ngOnInit() {
    this.ser.userBooks().subscribe((data: any) => {
      this.books = data.books;
      console.log(this.books);
    });
  }
}
